import React from "react";
import "./ViewHeader.css";

function ViewHeader({ children }) {
  return <div className="viewHeader">{children}</div>;
}

export default ViewHeader;
